import React from "react";
import PropTypes from "prop-types";
import stickybits from "stickybits";

import LpgDeutscheTelekomLogo from "@/icons/Lpg/DeutscheTelekomLogo";
import LpgSlogan from "@/icons/Lpg/Slogan";
import { A11yText } from "../A11yText";
import { Container } from "../Container";

import styles from "./BrandHeader.scss";

export class BrandHeader extends React.Component {
  static propTypes = {
    altLogo: PropTypes.string.isRequired,
    altSlogan: PropTypes.string.isRequired,
  };

  static defaultProps = {};

  static displayName = "BrandHeader";

  constructor(props) {
    super(props);

    this.state = {
      isHidden: false,
    };

    this.prev = 0;

    this.ref = React.createRef();
  }

  componentDidMount() {
    this.prev = window.pageYOffset;
    window.addEventListener("scroll", (e) => this.handleNavigation(e));

    this.stickyInstance = stickybits(this.ref.current, {
      stickyBitStickyOffset: 0,
      useStickyClasses: true,
    });
  }

  componentWillUnmount() {
    this.stickyInstance.cleanup();
  }

  handleNavigation = (e) => {
    const window = e.currentTarget;

    if (this.prev > window.pageYOffset) {
      this.setState({
        isHidden: false,
      });
    } else if (this.prev < window.pageYOffset) {
      this.setState({
        isHidden: true,
      });
    }
    this.prev = window.pageYOffset < 0 ? 0 : window.pageYOffset;
  };

  render() {
    const { altLogo, altSlogan, ...restProps } = this.props;
    const { isHidden } = this.state;

    return (
      <>
        <div
          className={`${styles.BrandHeader} ${
            !isHidden ? styles.globalNavigationVisible : ""
          }`}
          ref={this.ref}
          {...restProps}
        >
          <Container variants={Container.Variant.centered}>
            <Container variants={Container.Variant.fixed}>
              <div className={styles.main}>
                <a className={styles.logo} href="/">
                  <A11yText>{altLogo}</A11yText>
                  <LpgDeutscheTelekomLogo focusable="true" />
                </a>
                <div className={styles.sloganWrapper}>
                  <span className={styles.slogan}>
                    <A11yText>{altSlogan}</A11yText>
                    <LpgSlogan focusable="false" />
                  </span>
                </div>
              </div>
            </Container>
          </Container>
        </div>
      </>
    );
  }
}

export default BrandHeader;
